var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('input',{staticClass:"w-full p-2 px-4 rounded-lg bg-base-300",attrs:{"type":"search","placeholder":"search","name":"search","id":""}})])])
}]

export { render, staticRenderFns }